import { createVNode, render, nextTick } from 'vue'
import { ToTooltip } from '@touchvue/components'
function setTip(el, binding) {
	let color = Object.keys(binding.modifiers)[0]
	let position = Object.keys(binding.modifiers)[1]
	let align = Object.keys(binding.modifiers)[2]
	let delay = null
	//插槽文本内容
	let value = binding.value
	if (!value) {
		return
	}
	if (Object.prototype.toString.call(value) === '[object Object]') {
		if (!color) {
			color = binding.value.color
		}
		if (!position) {
			position = binding.value.position
		}
		if (!align) {
			align = binding.value.align
		}
		delay = binding.value.delay
		value = binding.value.value
	}
	function isStandardColor() {
		return ['primary', 'success', 'danger', 'warning', 'info', 'bg'].includes(color)
	}
	const tooltip = createVNode(
		ToTooltip,
		{
			event: '',
			shadow: false,
			position: position || 'auto',
			align: align || 'auto',
			color: color && isStandardColor() ? color : '',
			width: '',
			lazy: true,
			closeOnBlur: true,
			isScrollClose: true,
			delay: delay || 0,
			mode: !isStandardColor() && color ? color : ''
		},
		{
			default: () => value
		}
	)
	const container = document.createElement('div')
	render(tooltip, container)
	document.body.appendChild(container)
	nextTick(() => {
		el._tip = {
			vnode: tooltip,
			container
		}
		const open = () => {
			tooltip.component.exposed.open(el)
		}
		const close = () => {
			tooltip.component.exposed.close(el)
		}
		// 参数 click,弹出方式
		if (binding.arg) {
			el.addEventListener('click', open)
		} else {
			el.addEventListener('mouseenter', open)
			el.addEventListener('mouseleave', close)
		}
	})
}
const tipDirective = {
	mounted(el, binding) {
		setTip(el, binding)
	},
	updated(el, binding) {
		setTip(el, binding)
	},
	unmounted(el) {
		if (el._tip) {
			el.removeEventListener('click', open)
			el.removeEventListener('mouseenter', open)
			el.removeEventListener('mouseleave', close)
			render(null, el._tip.container)
			document.body.removeChild(el._tip.container)
			delete el._tip
		}
	}
}

export default tipDirective
